import { Subscription, SubscriptionStatus } from "fond/types";

export const isSubscriptionActive = (license: Subscription): boolean => {
  return license.Status === SubscriptionStatus.Active;
};

export const getTotalActiveLicenses = (accountSubscriptions: Subscription[] | undefined): number => {
  return accountSubscriptions?.filter(isSubscriptionActive)?.reduce((total, subscription) => total + subscription.LicenseCount, 0) || 0;
};
